export let webdesignProjects = [
	{
		title: 'Musica Erudita',
		urlRepository: 'https://github.com/ahoymarcus/musica-erudita',
		urlApp: 'https://musica-erudita.netlify.app/',
		image: '/images/web-design/mus-erudita-icon-bigger-page.png',
		description: 'Meu site pessoal de estudo Web Design: páginas responsivas, padrão “mobile-first”, SASS Modular, css-Grid, SVG-Animation (ver 2.0)',
		tags: ['html', 'css', 'javascript', 'sass', 'svg-animation'],
	},
    {
		title: 'Odin Recipes',
		urlRepository: 'https://github.com/ahoymarcus/odin-recipes',
		urlApp: 'https://ahoymarcus.github.io/odin-recipes/index.html',
		image: '/images/web-design/odin-recipes-brownies-page-02.png',
		description: 'Primeiro projeto da certificação da plataforma The Odin Project. Trata-se do design de um web site que recebe várias páginas de receitas.',
		tags: ['html', 'css', 'css-pattern'],
	},
	{
		title: 'Tribure Page',
		urlRepository: 'https://github.com/ahoymarcus/tribute-page-freecodecamp',
		urlApp: 'https://tribute-page-bach-freecodecamp.netlify.app/',
		image: '/images/web-design/tribure-page-icon-complete-page.png',
		description: 'Projeto da certificação Web Design da Frecodecamp.org de 300hs. Trata-se do design de uma página web com o intento de fazer tributo a pessoas célebres.',
		tags: ['html', 'css'],
	},
	{
		title: 'Technical Documentation Clone Page',
		urlRepository: 'https://github.com/ahoymarcus/technical-documentation-page-freecodecamp',
		urlApp: 'https://technical-mongodb-mockup-doc-page-freecodecamp.netlify.app/',
		image: '/images/web-design/technical-page-icon-bigger-page.png',
		description: 'Projeto da certificação Web Design da Frecodecamp.org de 300hs. Trata-se do desafio de clonar páginas web conhecidas. No caso deste projeto, foi clonada uma página de documentação do banco de dados MongoDB.',
		tags: ['html', 'css'],
	},
	{
		title: 'Galeria de Imagens',
		urlRepository: 'https://github.com/ahoymarcus/css3-com-grid-system-transform-property',
		urlApp: 'https://css3-com-grid-system-transform-property.netlify.com/coro-galeria-de-imagens.html',
		image: '/images/web-design/galeriaimgs-icon-bigger-page.png',
		description: 'Página de treino voltada à prática de algumas propriedades css, entre elas o Grid System e css Transformation.',
		tags: ['html', 'css', 'Grid System'],
	},
	{
		title: 'Clone NetFlix',
		urlRepository: 'https://github.com/ahoymarcus/clone-netflix',
		urlApp: 'https://clone-netflix-com-dio.netlify.app/',
		image: '/images/web-design/clone-netflix-icon.png',
		description: 'Projeto CLONE NETFLIX com a Digital Innovation One. Recriando a interface do principal site de streaming utilizando tecnologias como HTML5, CSS3 e javascript.',
		tags: ['html', 'css', 'variávies css', 'flexbox', 'plugins jquery', 'font awesome', 'javascript'],
	},
	{
		title: 'Survey Form',
		urlRepository: 'https://github.com/ahoymarcus/survey-form-freecodecamp',
		urlApp: 'https://buil-a-survey-form-freecodecamp.netlify.app/',
		image: '/images/web-design/form-page-icon.png',
		description: 'Projeto da certificação Web Design da Frecodecamp.org de 300hs. O desafio consta de criar uma página web com formulário.',
		tags: ['html', 'css'],
	},
	{
		title: 'Clone Instagram',
		urlRepository: 'https://github.com/ahoymarcus/flexbox-instagram',
		urlApp: 'https://flexbox-instagram-com-dio.netlify.app/',
		image: '/images/web-design/clone-instagram-icon.png',
		description: 'Projeto do curso de web desing da Digital Innovation One para clonar a página inicial do Instagram.',
		tags: ['html', 'css'],
	},
];




